import React from "react";
import ReactDom from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";
import { Provider } from "react-redux";
import createStore from "./components/Store";
import { bootstrapStencil } from '../stencil-wrapper';
// require("typeface-inter");
/*
import { createReactComponent } from '@softix/ui-components/dist/stx-components-react/src/react-component-lib';

import { JSX as LocalJSX } from '@softix/ui-components/loader'
import { DetailedHTMLProps, HTMLAttributes } from 'react';


type StencilProps<T> = {
    [P in keyof T]?: Omit<T[P], 'ref'> | HTMLAttributes<T>;
};

type ReactProps<T> = {
    [P in keyof T]?: DetailedHTMLProps<HTMLAttributes<T[P]>, T[P]>;
};

type StencilToReact<T = LocalJSX.IntrinsicElements, U = HTMLElementTagNameMap> = StencilProps<T> &
    ReactProps<U>;

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    export namespace JSX {
        interface IntrinsicElements extends StencilToReact { }
    }
}
*/

//import type { JSX } from '@softix/ui-components/dist/types';

//defineCustomElements();

//export const StxInternationalPhoneField = /*@__PURE__*/createReactComponent<JSX.StxInternationalPhoneField, HTMLStxInternationalPhoneFieldElement>('stx-international-phone-field');


const bootstrapReact = (environment) => {

  const root = document.getElementById("root");
  bootstrapStencil();
  const store = createStore(environment);

  let rootComponent= (
    <Provider store={store}>
      <Router>
        <App env={environment}/>
      </Router>
    </Provider>
  );
  ReactDom.render(rootComponent, root);
} 
window.onload = () => {
  fetch('/templates/'+ window.location.host.split(':')[0] + '.json')
  .then(response => response.json())
  .then(data => bootstrapReact(data));
}

/**
 * old scripts
 * "scripts": {
    "start": "cd dist && node index",
    "dev": "webpack-dev-server -d --hot --open",
    "build": "npm run build-client && npm run build-server",
    "build-client": "webpack --mode production",
    "build-server": "webpack --mode production --config webpack.config.server.js",
    "heroku-postbuild": "npm run build",
    "test": "jest",
    "test:watch": "jest --watch"
  },
 */
